<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>Wareneingang anlegen</modal-header>
            <modal-content>
                <form-datepicker id="incoming_goods_at" label="Eingangsdatum" name="incoming_goods_at" v-model:date="form.incoming_goods_at" :error="form.errors.incoming_goods_at" />

                <form-select id="producer_order_id" label="Lieferung" name="producer_order_id"
                             :options="producerOrder" v-model="form.producer_order_id"
                             :error="form.errors.producer_order_id"/>
                <form-input id="amount" :label="'Stückzahl'" name="amount" v-model="form.amount"
                            :error="form.errors.amount" autocomplete="off"/>

                <label>Eingangskontrolle</label>
                <div class="form-element">
                    <table class="table table--stripped">
                        <tbody>
                        <tr>
                            <td>Ware gut verpackt?</td>
                            <td>
                                <form-radio id="shipping_good_true" name="shipping_good" value="1"
                                            v-model:checked="form.shipping_good" option="Ja"/>
                            </td>
                            <td>
                                <form-radio id="shipping_good_false" name="shipping_good" value="0"
                                            v-model:checked="form.shipping_good" option="Nein"/>
                            </td>
                        </tr>
                        <tr>
                            <td>Ware unbeschädigt, Sichtprüfung</td>
                            <td>
                                <form-radio id="shipping_ok_true" name="shipping_ok" value="1"
                                            v-model:checked="form.shipping_ok" option="Ja"/>
                            </td>
                            <td>
                                <form-radio id="shipping_ok_false" name="shipping_ok" value="0"
                                            v-model:checked="form.shipping_ok" option="Nein"/>
                            </td>
                        </tr>
                        <tr>
                            <td>Sauber und entgratet</td>
                            <td>
                                <form-radio id="shipping_right_true" name="shipping_right" value="1"
                                            v-model:checked="form.shipping_right" option="Ja"/>
                            </td>
                            <td>
                                <form-radio id="shipping_right_false" name="shipping_right" value="0"
                                            v-model:checked="form.shipping_right" option="Nein"/>
                            </td>
                        </tr>
                        <tr>
                            <td>Messprüfung durchgeführt</td>
                            <td>
                                <form-radio id="measuring_done_true" name="measuring_done" value="1"
                                            v-model:checked="form.measuring_done" option="Ja"/>
                            </td>
                            <td>
                                <form-radio id="measuring_done_false" name="measuring_done" value="0"
                                            v-model:checked="form.measuring_done" option="Nein"/>
                            </td>
                        </tr>
                        <tr>
                            <td>Messprüfung bestanden</td>
                            <td>
                                <form-radio id="measuring_ok_true" name="measuring_ok" value="1"
                                            v-model:checked="form.measuring_ok" option="Ja"/>
                            </td>
                            <td>
                                <form-radio id="measuring_ok_false" name="measuring_ok" value="0"
                                            v-model:checked="form.measuring_ok" option="Nein"/>
                            </td>
                        </tr>
                        <tr>
                            <td>Qualitätskontrolle bestanden</td>
                            <td>
                                <form-radio id="quality_control_true" name="quality_control" value="1"
                                            v-model:checked="form.quality_control" option="Ja"/>
                            </td>
                            <td>
                                <form-radio id="quality_control_false" name="quality_control" value="0"
                                            v-model:checked="form.quality_control" option="Nein"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <form-text id="comment" label="Kommentar" name="comment" v-model="form.comment" :error="form.errors.comment" />
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">Speichern</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import {useForm} from '@inertiajs/vue3';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormText from '@partfactory/Shared/Form/FormText';
import FormRadio from '@partfactory/Shared/Form/FormRadio';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';

export default {
    name: 'IncomingGoodsProducerModal',
    components: {
        FormDatepicker,
        FormRadio, FormText, FormInput, FormSelect, FormButton, ModalActions, Modal, ModalContent, ModalHeader
    },
    props: {
        incomingGoodsProducer: Object,
        askForQuote: Object,
    },
    emit: ['closeDialog'],
    data() {
        const currentDate = this.$moment(new Date, 'YYYY-MM-DD').format('YYYY-MM-DD');
        const form = useForm({
            incoming_goods_at: this.incomingGoodsProducer?.incoming_goods_at ? this.incomingGoodsProducer?.incoming_goods_at : currentDate,
            producer_order_id: this.incomingGoodsProducer?.producer_order_id ? this.incomingGoodsProducer?.producer_order_id : this.askForQuote.producer_order.id,
            amount: this.incomingGoodsProducer?.amount ? this.incomingGoodsProducer?.amount : null,
            comment: this.incomingGoodsProducer?.comment ? this.incomingGoodsProducer?.comment : null,
            shipping_good: this.incomingGoodsProducer?.shipping_good ? this.incomingGoodsProducer?.shipping_good : 0,
            shipping_ok: this.incomingGoodsProducer?.shipping_ok ? this.incomingGoodsProducer?.shipping_ok : 0,
            shipping_right: this.incomingGoodsProducer?.shipping_right ? this.incomingGoodsProducer?.shipping_right : 0,
            measuring_done: this.incomingGoodsProducer?.measuring_done ? this.incomingGoodsProducer?.measuring_done : 0,
            measuring_ok: this.incomingGoodsProducer?.measuring_ok ? this.incomingGoodsProducer?.measuring_ok : 0,
            quality_control: this.incomingGoodsProducer?.quality_control ? this.incomingGoodsProducer?.quality_control : 0,
        });

        return {form};
    },
    computed: {
        producerOrder() {
            let producerOrder = [];
            producerOrder.push({value: this.askForQuote.producer_order.id, text: this.askForQuote.producer_order.pf_order_number_producer + ' (' + this.askForQuote.producer_order.producer_user.prod_no + ' ' + this.askForQuote.producer_order.producer_user.name + ')'});
            return producerOrder;
        },
        maxIncomingQty() {
            let maxIncomingQty = this.askForQuote.producer_order.amount;
            this.askForQuote?.incoming_goods_producer?.forEach((incoming) => {
                maxIncomingQty -= incoming.amount;
            });
            return maxIncomingQty;
        },
    },
    methods: {
        submit() {
            if (this.incomingGoodsProducer) {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                    }))
                    .patch(this.$$route('ask-for-quote.delivery.incoming-goods-producer.patch', {'askForQuote': this.askForQuote.id, 'incomingGoodsProducer': this.incomingGoodsProducer.id}), {
                        onSuccess: () => this.$emit('closeDialog'),
                    });
            } else {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                    }))
                    .post(this.$$route('ask-for-quote.delivery.incoming-goods-producer', {'askForQuote': this.askForQuote.id}), {
                        onSuccess: () => this.$emit('closeDialog'),
                    });
            }

        },
    },
};
</script>
